import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

const API_URL = `${URL}/api/users`;

export const impersonateUser = async (userId) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/${userId}/impersonate`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
